import { Component } from 'react'
import { DonateButton, ProjectComponent, SubscribeModal, StickyPhone } from 'ppp'
import { ShareButtons, gaEvent } from 'shared'
import formatNumber from 'shared/format_number'
import debug from 'shared/debug'

export class Sticky extends ProjectComponent {
  showSubscriptionModal = () => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__sticky')
    this.setState({showSubscriptionModal: true})
  }

  hideSubscriptionModal = () => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__sticky')
    this.setState({showSubscriptionModal: false})
  }

  activeClassFor = (tab) => {
    if (tab == this.props.activeTab) return 'active'
    else return ''
  }

  render() {
    return <>
      <div className='container'>
        <div className='row'>
          <div className='col-md-16' style={{minHeight: 0}}>
            <ul className='list-unstyled navigation-list'>
              <AdminButton manageUrl={ this.props.manageUrl } />
              <li className={ this.activeClassFor('overview') }>
                <a href={ this.props.pppUrl }>
                  <span className='d-none d-md-inline'>{ I18n.t('projects.show.sticky.overview_button_label') }</span>
                  <span className='d-md-none'>{ I18n.t('projects.show.sticky.overview_button_mobile_label') }</span>
                </a>
              </li>
              <li className={ this.activeClassFor('opinions') }>
                <a href={ this.props.opinionsUrl }>
                  { I18n.t('projects.show.sticky.donation_list_button_label') } <span className='d-none d-md-inline'>({ formatNumber(this.state.project.donations_count) })</span>
                </a>
              </li>
              <li className={this.activeClassFor('news')}>
                <a href={this.props.newsUrl}>
                  {I18n.t('projects.show.sticky.news_button_label')} <span className='d-none d-md-inline'>({formatNumber(this.state.project.blog_post_count)})</span>
                </a>
              </li>
              <li className={ this.activeClassFor('comments') }>
                <a href={ this.props.commentsUrl }>
                  { I18n.t('projects.show.sticky.comments_button_label') } <span className='d-none d-md-inline'>({ formatNumber(this.state.project.comments_count) })</span>
                </a>
              </li>
            </ul>
          </div>
          <div className='col-md-8'>
            <div className='meta-navigation'>
              <SubscribeModal
                show={this.state.showSubscriptionModal}
                project={this.state.project}
                onHide={this.hideSubscriptionModal}
                url={this.props.newsletterSubscriptionUrl}
              />

              <ShareButtons
                platforms={['facebook', 'whatsapp']}
                mobileOnly={['whatsapp']}
                shape='square'
                shareUrl={this.props.shareUrl}
                status={this.status}
                className='without-labels'
                gaLabel='ppp_sticky'>

                <a className='heart-shape-container'
                  onClick={this.showSubscriptionModal}
                  title={I18n.t('projects.show.share_buttons.become_a_fan')}>
                  <i className='fa fa-heart' />
                </a>
              </ShareButtons>
              <DonateButton project={this.state.project} status={this.status} gaAction='click donate_button__sticky' additionalClass='btn-large'/>
            </div>
          </div>
        </div>
      </div>
      <StickyPhone project={this.state.project} status={this.status} />
    </>
  }
}

// Determines via HEAD request if a manager is logged in or not.
// If yes the "Administration"-button is shown.
class AdminButton extends Component {
  constructor(props) {
    super(props)
    this.state = { isManager: false }
  }

  componentDidMount() {
    fetch(this.props.manageUrl, { method: 'HEAD', credentials: 'same-origin', redirect: 'manual' })
      .then(this.handleManageCheck)
      .then(undefined, err => debug(err))
  }

  handleManageCheck = (response) => {
    if (response.status == 200) {
      // fetch polyfill does not support "redirect" option, that's why we need
      // to check that again here
      if (response.url.includes("users/sign_in")) return

      this.setState({ isManager: true })
    }
  }

  render() {
    if (!this.state.isManager) return null

    return <li className='admin-tab'>
      <a className='generic-admin-box as-button' href={ this.props.manageUrl }>
        { I18n.t('projects.show.sticky.manage_button_label') }
      </a>
    </li>
  }
}
